import { AuctionBidAdminDTO } from "./auctionBidAdminDTO";

export class AuctionBidHistoryDTO{
    public auctionId!:number;
    public scheduleSeqNo!:number;
    public void:boolean = false;
    public voidIndex?:number;
    public auctionBids!:AuctionBidAdminDTO[];
}